module.exports = __webpack_public_path__ + "static/media/CW Headshot_1689852623333.b13957c1.jpg";